import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'

import NavDropdown, { DropdownLink } from '../NavDropdown'

import styles from './styles'

const NavMenu = ({
  candidateSlug,
  candidateState,
  disabledCandidate,
  unreadInterviewRequestCount,
  signOut,
  emailPreferencesAccessTokenKey,
}) => (
  <ul className={styles.navigation}>
    <li>
      <NavLink exact to={`/candidate/${candidateSlug}/dashboard`} className={styles.link} activeClassName={styles.activeLink}>
        Dashboard
      </NavLink>
    </li>

    <li>
      <NavLink exact to={`/candidate/${candidateSlug}`} className={styles.link} activeClassName={styles.activeLink}>
        Profile
      </NavLink>
    </li>

    <li>
      <NavLink
        to={`/candidate/${candidateSlug}/recommended-jobs`}
        className={styles.link}
        activeClassName={styles.activeLink}
        isActive={(match, location) => match || location.pathname === `/candidate/${candidateSlug}/applications`}>
        Jobs
      </NavLink>
    </li>

    <If condition={!disabledCandidate}>
      <li>
        <NavLink to={`/candidate/${candidateSlug}/interview_requests`} className={styles.link} activeClassName={styles.activeLink}>
          Interviews
          <If condition={unreadInterviewRequestCount > 0}>
            <span className={styles.unread}>{unreadInterviewRequestCount}</span>
          </If>
        </NavLink>
      </li>
    </If>

    <If condition={['ready_to_go_live', 'live', 'post_live'].includes(candidateState)}>
      <li>
        <a href={`/candidate/${candidateSlug}/calendar`} className={styles.link}>
          Calendar
        </a>
      </li>
    </If>

    <li>
      <NavDropdown className={styles.dropdown} label="More">
        <DropdownLink label="Account details" href={`/candidate/${candidateSlug}/account/details`} />
        <DropdownLink label="Email preferences" href={`/email_preferences/${emailPreferencesAccessTokenKey}`} />
        <DropdownLink label="Manage your data" href={`/candidate/${candidateSlug}/account/manage_data`} />
        <DropdownLink label="Invite Friends" href={`/candidate/${candidateSlug}/referrals`} />
        <DropdownLink label="Privacy Centre" href="/privacy-centre" target="_blank" />
        <DropdownLink label="Log out" onClick={signOut} rel="nofollow" />
      </NavDropdown>
    </li>
  </ul>
)

NavMenu.propTypes = {
  candidateSlug: PropTypes.string,
  candidateState: PropTypes.string,
  disabledCandidate: PropTypes.bool,
  unreadInterviewRequestCount: PropTypes.number,
  signOut: PropTypes.func,
  emailPreferencesAccessTokenKey: PropTypes.string,
}

export default NavMenu
